import { useEffect,useState } from "react";
import { getherosection } from "../services/heroapi";

let cachedData = null;

const useHero =() => {
    const [hero, sethero] = useState(cachedData || []);
    const [loading, setLoading] = useState(!cachedData);
    const [error, setError] = useState(null);


    useEffect(()=>{
        if (!cachedData) {
        const fetchData = async()=>{
            try {
                const data = await getherosection();
                cachedData = data; 
                sethero(data);
            }catch(err){
                console.error('Error fetching blogs:',err);
                setError('Failed to fetch blogs');
            }finally{
                setLoading(false);
            }
        }
        fetchData();
    }
    },[]);

    return {hero, loading, error};

}

export default useHero;